export default __webpack_public_path__ + "static/media/tiivii-guia-escritorio-2.74bc17d9.png";